import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { anaApi, apiError, mediaUrl } from "../lib/api";
import { renderRich } from "../lib/richText";
import { AnaChart } from "../components/ana/AnaChart";

export default function ReporteAna() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { setR(null); anaApi.reporte(id).then(setR).catch((e) => setErr(apiError(e))); }, [id]);

  if (err) return <div className="min-h-screen bg-cream grid place-items-center text-[#0A1C30] font-bold" data-testid="reporte-ana-error">{err}</div>;
  if (!r) return <div className="min-h-screen bg-cream grid place-items-center"><Loader2 className="w-8 h-8 animate-spin text-[#E9A400]" /></div>;
  return (
    <div className="min-h-screen bg-cream" data-testid="reporte-ana-page">
      <div className="bg-[#0A1C30] text-white">
        <div className="max-w-4xl mx-auto px-5 py-8">
          <button data-testid="reporte-ana-back" onClick={() => navigate("/mi-cuenta")} className="inline-flex items-center gap-2 text-sm font-bold text-white/70 hover:text-white"><ArrowLeft className="w-4 h-4" /> Mi cuenta</button>
          <div className="mt-6 flex items-center gap-4">
            {r.foto_url ? <img src={mediaUrl(r.foto_url)} alt="Ana" className="w-16 h-16 rounded-full object-cover ring-2 ring-[var(--gold)]" />
              : <span className="w-16 h-16 rounded-full bg-[var(--gold)] text-[#0A1C30] font-extrabold grid place-items-center text-2xl">A</span>}
            <div>
              <div className="text-[10px] font-extrabold tracking-[0.25em] text-[var(--gold)]">REPORTE SEMANAL · {r.semana}</div>
              <h1 className="text-2xl sm:text-3xl font-extrabold" data-testid="reporte-ana-title">{r.child_nombre}</h1>
            </div>
          </div>
          {r.hermanos?.length > 1 && (
            <div className="mt-5 flex flex-wrap gap-2">
              {r.hermanos.map((h) => (
                <button key={h.id} data-testid={`reporte-ana-hijo-${h.id}`} onClick={() => navigate(`/reporte-ana/${h.id}`)}
                  className={`text-xs font-bold rounded-full px-3 py-1.5 ${h.id === r.id ? "bg-[var(--gold)] text-[#0A1C30]" : "bg-white/10 text-white"}`}>{h.child_nombre}</button>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-5 py-8 space-y-6">
        <div className="rounded-3xl bg-white ring-1 ring-black/5 p-6 text-sm blog-rich" data-testid="reporte-ana-texto" dangerouslySetInnerHTML={{ __html: renderRich(r.texto) }} />
        <div className="grid sm:grid-cols-2 gap-4 items-start">{r.charts.map((c, i) => <AnaChart key={i} c={c} i={i} />)}</div>
      </div>
    </div>
  );
}
